<mat-toolbar class="subtitulo">
    <button mat-icon-button (click)="voltar()" matTooltip="Voltar">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Associação de Lançamentos com Conta Contábil - {{ arquivo?.nomeArquivo }}</span>
</mat-toolbar>

<!-- ============================================================
     Templates compartilhados pelas três abas de lançamentos.
     Cada lançamento é exibido em um cartão com duas linhas:
       1) data, descrição/beneficiário, valor, situação e ações
       2) campos de associação (conta contábil, conta contábil adicional,
          empresa, tipo importação e histórico)
     ============================================================ -->

<!-- Dados básicos do lançamento -->
<ng-template #dadosLancamentoTpl let-linha="linha">
    <div class="lancamento-data">
        <mat-icon>event</mat-icon>
        <span>{{ formatarData(linha.dataExtrato) }}</span>
    </div>
    <div class="lancamento-descricao">
        <div class="descricao-transacao">{{ linha.descricaoTransacao }}</div>
        <div class="beneficiario" *ngIf="linha.descricaoBeneficiario">
            {{ linha.descricaoBeneficiario }}
        </div>
    </div>
    <div class="lancamento-valor" [style.color]="obterCorValor(linha.valorExtrato)">
        {{ formatarValor(linha.valorExtrato) }}
    </div>
</ng-template>

<!-- Campos de associação do lançamento -->
<ng-template #camposLancamentoTpl let-linha="linha" let-desabilitado="desabilitado" let-desabilitadoConta="desabilitadoConta">
    <div class="lancamento-campos">
        <div class="campo campo-conta">
            <app-combo-generico
                    (mudancaSelecao)="onCategoriaChange(linha, $event)"
                    [placeholder]="'Conta Contábil'"
                    [configuracao]="configuracaoSeletorCategoria"
                    [opcoes]="planosContas"
                    [valor]="getCategoriaIdLinha(linha)"
                    [desabilitado]="desabilitadoConta">
            </app-combo-generico>
        </div>
        <div class="campo campo-conta-adicional">
            <app-combo-generico
                    (mudancaSelecao)="onCategoriaAdicionalChange(linha, $event)"
                    [placeholder]="'Conta Contábil Adicional'"
                    [configuracao]="configuracaoSeletorCategoria"
                    [opcoes]="planosContas"
                    [valor]="getCategoriaAdicionalIdLinha(linha)"
                    [desabilitado]="desabilitado">
            </app-combo-generico>
        </div>
        <div class="campo campo-empresa">
            <app-combo-generico
                    (mudancaSelecao)="onEmpresaChange(linha, $event)"
                    [placeholder]="'Empresa (opcional)'"
                    [configuracao]="configuracaoSeletorEmpresa"
                    [opcoes]="empresas"
                    [valor]="getEmpresaIdLinha(linha)"
                    [desabilitado]="desabilitado">
            </app-combo-generico>
        </div>
        <div class="campo campo-tipo-lancamento">
            <app-combo-generico
                    (mudancaSelecao)="onTipoLancamentoChange(linha, $event)"
                    [placeholder]="'Tipo Importação'"
                    [configuracao]="configuracaoSeletorTipoLancamento"
                    [opcoes]="tiposLancamento"
                    [valor]="getTipoLancamentoIdLinha(linha)"
                    [desabilitado]="desabilitado">
            </app-combo-generico>
        </div>
        <div class="campo campo-historico">
            <mat-form-field style="width: 100%;">
                <input matInput
                       [(ngModel)]="linha.descricaoLinha"
                       (blur)="onDescricaoLinhaChange(linha, linha.descricaoLinha)"
                       placeholder="Histórico"
                       maxlength="500"
                       [disabled]="desabilitado">
            </mat-form-field>
        </div>
    </div>
</ng-template>

<div style="padding: 20px;">
    <!-- Resumo Detalhado da Associação -->
    <div *ngIf="estatisticas.totalLinhas > 0" class="resumo-associacao">
        <mat-card class="resumo-card">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>analytics</mat-icon>
                    Resumo da Associação
                </mat-card-title>
                <div class="resumo-header-actions">
                    <button mat-icon-button (click)="toggleResumo()"
                            matTooltip="{{ resumoExpandido ? 'Ocultar detalhes' : 'Mostrar detalhes' }}">
                        <mat-icon>{{ resumoExpandido ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </div>
            </mat-card-header>
            <mat-card-content *ngIf="resumoExpandido">
                <div class="resumo-content">
                    <!-- Status Geral -->
                    <div class="status-geral">
                        <div class="status-info">
                            <span class="status-label">Status Geral:</span>
                            <span [style.color]="obterCorStatusAssociacao()" class="status-value">
                                {{ obterStatusAssociacaoTexto() }}
                            </span>
                        </div>
                        <div class="progresso-info">
                            <span class="progresso-label">Progresso:</span>
                            <span class="progresso-value">{{ estatisticas.percentualAssociacao }}%</span>
                        </div>
                    </div>

                    <!-- Barra de Progresso -->
                    <div class="progresso-bar">
                        <div class="progresso-fill"
                             [style.background-color]="obterCorStatusAssociacao()"
                             [style.width.%]="estatisticas.percentualAssociacao">
                        </div>
                    </div>

                    <!-- Estatísticas Detalhadas -->
                    <div class="estatisticas-detalhadas">
                        <div class="estatistica-item">
                            <mat-icon>list_alt</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Total de Lançamentos</span>
                                <span class="estatistica-value">{{ estatisticas.totalLinhas }}</span>
                            </div>
                        </div>
                        <div class="estatistica-item">
                            <mat-icon>check_circle</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Associadas</span>
                                <span class="estatistica-value">{{ estatisticas.associadas }}</span>
                            </div>
                        </div>
                        <div class="estatistica-item">
                            <mat-icon>pending</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Sem conta contábil</span>
                                <span class="estatistica-value">{{ estatisticas.semContaContabil }}</span>
                            </div>
                        </div>
                        <div class="estatistica-item">
                            <mat-icon>block</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Ignoradas</span>
                                <span class="estatistica-value">{{ estatisticas.ignoradas }}</span>
                            </div>
                        </div>
                        <div class="estatistica-item" *ngIf="estatisticas.duplicadas > 0">
                            <mat-icon>error</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Duplicadas</span>
                                <span class="estatistica-value">{{ estatisticas.duplicadas }}</span>
                            </div>
                        </div>
                        <div class="estatistica-item estatistica-item-integracao" *ngIf="estatisticas.pendentesIntegracao > 0">
                            <mat-icon>warning</mat-icon>
                            <div class="estatistica-info">
                                <span class="estatistica-label">Pend. Integração</span>
                                <span class="estatistica-value">{{ estatisticas.pendentesIntegracao }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Valores Financeiros -->
                    <div class="valores-financeiros">
                        <div class="valor-item">
                            <mat-icon>account_balance_wallet</mat-icon>
                            <div class="valor-info">
                                <span class="valor-label">Valor Total</span>
                                <span class="valor-value">{{ formatarValor(estatisticas.valorTotal) }}</span>
                            </div>
                        </div>
                        <div class="valor-item">
                            <mat-icon>check_circle</mat-icon>
                            <div class="valor-info">
                                <span class="valor-label">Valor Associado</span>
                                <span class="valor-value"
                                      style="color: #4caf50;">{{ formatarValor(estatisticas.valorAssociado) }}</span>
                            </div>
                        </div>
                        <div class="valor-item">
                            <mat-icon>pending</mat-icon>
                            <div class="valor-info">
                                <span class="valor-label">Valor Pendente</span>
                                <span class="valor-value"
                                      style="color: #f44336;">{{ formatarValor(estatisticas.valorPendente) }}</span>
                            </div>
                        </div>
                        <div class="valor-item">
                            <mat-icon>block</mat-icon>
                            <div class="valor-info">
                                <span class="valor-label">Valor Ignorado</span>
                                <span class="valor-value"
                                      style="color: #ff9800;">{{ formatarValor(estatisticas.valorIgnorado) }}</span>
                            </div>
                        </div>
                        <div class="valor-item" *ngIf="estatisticas.valorDuplicado !== 0">
                            <mat-icon>error</mat-icon>
                            <div class="valor-info">
                                <span class="valor-label">Valor Duplicado</span>
                                <span class="valor-value"
                                      style="color: #9e9e9e;">{{ formatarValor(estatisticas.valorDuplicado) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Configuração do Arquivo -->
    <div class="configuracao-arquivo" *ngIf="arquivo">
        <mat-card class="configuracao-card">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>settings</mat-icon>
                    Informações do Arquivo
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <!-- Informações do Arquivo -->
                <div class="info-row" style="margin-bottom: 20px;">
                    <div class="info-item">
                        <mat-icon>description</mat-icon>
                        <span><strong>Arquivo:</strong> {{ arquivo.nomeArquivo }}</span>
                    </div>
                    <div class="info-item">
                        <mat-icon>schedule</mat-icon>
                        <span><strong>Importado em:</strong> {{ formatarData(arquivo.dataImportacao) }}</span>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutGap="20px" fxFlexFill style="padding-bottom: 30px">

                    <!-- Conta Bancária -->
                    <div fxFlex="45%">
                        <app-combo-generico
                                (mudancaSelecao)="onContaBancariaChange($event)"
                                [placeholder]="'Conta Bancária do Arquivo'"
                                [configuracao]="configuracaoSeletorContaBancaria"
                                [opcoes]="contasBancariasOpcoes"
                                [valor]="arquivo.contaBancaria?.id"
                                [desabilitado]="(!perfilAcesso.insere && !perfilAcesso.altera) || arquivo.finalizado">
                        </app-combo-generico>
                        <div style="font-size: 75%; margin-top: -15px; color: rgba(0, 0, 0, 0.54);">
                            Selecione a conta bancária vinculada a este arquivo de extrato
                        </div>
                    </div>

                    <!-- Conta Contábil -->
                    <div fxFlex="45%" fxFlexOffset="20px">
                        <app-combo-generico
                                (mudancaSelecao)="onCategoriaArquivoChange($event)"
                                [placeholder]="'Conta Contábil do Arquivo'"
                                [configuracao]="configuracaoSeletorCategoria"
                                [opcoes]="planosContas"
                                [valor]="arquivo.categoriaContabil?.id"
                                [desabilitado]="(!perfilAcesso.insere && !perfilAcesso.altera) || arquivo.finalizado">
                        </app-combo-generico>
                        <div style="font-size: 75%; margin-top: -15px; color: rgba(0, 0, 0, 0.54);">
                            Esta conta contábil será aplicada automaticamente: ORIGEM para débitos e DESTINO para créditos
                        </div>
                    </div>

                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Lançamentos do Extrato em abas -->
    <div class="lancamentos-tabs">
        <mat-tab-group>

            <!-- Aba: Pendentes de Importação -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon tab-icon-pendente">pending</mat-icon>
                    Pendentes de Importação
                    <span class="tab-badge tab-badge-pendente" *ngIf="contarPendentesTotal() > 0">
                        {{ contarPendentesTotal() }}
                    </span>
                </ng-template>

                <!-- Filtros -->
                <div class="filtros" style="margin-top: 16px;">
                    <mat-card>
                        <mat-card-content>
                            <div class="filtros-content">
                                <mat-radio-group [(ngModel)]="filtroSelecionado">
                                    <mat-radio-button value="todas" style="margin-right: 10px">
                                        Todas os lançamentos
                                    </mat-radio-button>
                                    <mat-radio-button value="validas" style="margin-right: 10px">
                                        Válidos
                                    </mat-radio-button>
                                    <mat-radio-button value="semContaContabil" style="margin-right: 10px">
                                        Sem conta contábil
                                    </mat-radio-button>
                                    <mat-radio-button value="ignoradas" style="margin-right: 10px">
                                        Ignorados
                                    </mat-radio-button>
                                    <mat-radio-button value="duplicadas" style="margin-right: 10px">
                                        Duplicados
                                    </mat-radio-button>
                                </mat-radio-group>
                                <div [style.opacity]="associacoes.size > 0 ? 1 : 0" class="modificadas-info">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{ associacoes.size }} lançamento(s) modificado(s)</span>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <!-- Lançamentos pendentes -->
                <div class="lancamentos-container">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Lançamentos do Extrato</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="lancamentos-lista">
                                <div *ngFor="let linha of obterLinhasFiltradas()"
                                     class="lancamento-item"
                                     [class.modificada]="isLinhaModificada(linha)"
                                     [class.ignorada]="isLinhaIgnorada(linha)"
                                     [class.associada]="isLinhaAssociada(linha)"
                                     [class.invalida]="linha.statusProcessado === 'I'">

                                    <!-- Linha 1: data, descrição, valor, situação e ações -->
                                    <div class="lancamento-resumo">
                                        <ng-container *ngTemplateOutlet="dadosLancamentoTpl; context: {linha: linha}"></ng-container>

                                        <div class="lancamento-situacao">
                                            <span *ngIf="linha.statusProcessado === 'I'"
                                                  class="situacao-chip situacao-duplicada"
                                                  matTooltip="Este lançamento foi invalidado por ser duplicado. A transação já foi importada em outro arquivo.">
                                                <mat-icon>content_copy</mat-icon>
                                                Duplicada
                                            </span>
                                            <span *ngIf="linha.statusProcessado !== 'I' && isLinhaIgnorada(linha)"
                                                  class="situacao-chip situacao-ignorada">
                                                <mat-icon>block</mat-icon>
                                                Ignorada
                                            </span>
                                            <span *ngIf="linha.statusProcessado !== 'I' && !isLinhaIgnorada(linha) && isLinhaAssociada(linha)"
                                                  class="situacao-chip situacao-associada">
                                                <mat-icon>check_circle</mat-icon>
                                                Associada
                                            </span>
                                            <span *ngIf="linha.statusProcessado !== 'I' && !isLinhaIgnorada(linha) && !isLinhaAssociada(linha)"
                                                  class="situacao-chip situacao-pendente">
                                                <mat-icon>pending</mat-icon>
                                                Sem conta contábil
                                            </span>
                                            <span *ngIf="isLinhaModificada(linha)"
                                                  class="situacao-chip situacao-modificada"
                                                  matTooltip="Alteração pendente de salvamento">
                                                <mat-icon>edit</mat-icon>
                                                Alterada
                                            </span>
                                        </div>

                                        <div class="lancamento-acoes" *ngIf="!isLinhaDesabilitada(linha)">
                                            <button *ngIf="!isLinhaIgnorada(linha) && (perfilAcessoSec.insere || perfilAcessoSec.altera)"
                                                    class="acao-btn acao-btn-add"
                                                    mat-button
                                                    (click)="abrirDialogCadastrarArgumento(linha)"
                                                    [disabled]="!podeAbrirDialogCadastrarArgumento()"
                                                    [matTooltip]="podeAbrirDialogCadastrarArgumento() ? 'Criar novo conjunto de contas contábeis' : 'Configure a Conta Contábil do Arquivo para criar conjuntos'">
                                                <mat-icon>add_circle</mat-icon>
                                            </button>
                                            <button *ngIf="!isLinhaIgnorada(linha)"
                                                    class="acao-btn acao-btn-auto"
                                                    mat-button
                                                    (click)="preencherCategoriaAutomaticamente(linha)"
                                                    [disabled]="!podePreencherAutomaticamente()"
                                                    matTooltip="Preenchimento automático para esta linha">
                                                <mat-icon>auto_fix_high</mat-icon>
                                            </button>
                                            <button *ngIf="!isLinhaIgnorada(linha)"
                                                    class="acao-btn acao-btn-block"
                                                    mat-button
                                                    (click)="ignorarLinha(linha)"
                                                    matTooltip="Ignorar linha">
                                                <mat-icon>block</mat-icon>
                                            </button>
                                            <button *ngIf="isLinhaIgnorada(linha)"
                                                    class="acao-btn acao-btn-undo"
                                                    mat-button
                                                    (click)="desfazerIgnorarLinha(linha)"
                                                    matTooltip="Desfazer ignorar">
                                                <mat-icon>undo</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Linha 2: campos de associação (não exibidos para lançamentos duplicados) -->
                                    <ng-container *ngIf="linha.statusProcessado !== 'I'">
                                        <ng-container *ngTemplateOutlet="camposLancamentoTpl; context: {
                                            linha: linha,
                                            desabilitado: isLinhaDesabilitada(linha),
                                            desabilitadoConta: isCategoriaDesabilitado(linha, linha.tipoTransacao === 'C')
                                        }"></ng-container>
                                    </ng-container>
                                </div>

                                <div *ngIf="obterLinhasFiltradas().length === 0" class="empty-state">
                                    <mat-icon>inbox</mat-icon>
                                    <p>Nenhum lançamento pendente encontrado</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>

            <!-- Aba: Importação com Êxito -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon tab-icon-ok">check_circle</mat-icon>
                    Importação com Êxito
                    <span class="tab-badge tab-badge-ok" *ngIf="obterLinhasImportadas().length > 0">
                        {{ obterLinhasImportadas().length }}
                    </span>
                </ng-template>

                <div class="lancamentos-container" style="margin-top: 16px;">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Lançamentos Importados</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="lancamentos-lista">
                                <div *ngFor="let linha of obterLinhasImportadas()"
                                     class="lancamento-item associada">

                                    <!-- Linha 1: data, descrição, valor e situação -->
                                    <div class="lancamento-resumo">
                                        <ng-container *ngTemplateOutlet="dadosLancamentoTpl; context: {linha: linha}"></ng-container>

                                        <div class="lancamento-situacao">
                                            <span class="situacao-chip situacao-associada">
                                                <mat-icon>check_circle</mat-icon>
                                                Importada
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Linha 2: campos de associação (somente leitura) -->
                                    <ng-container *ngTemplateOutlet="camposLancamentoTpl; context: {
                                        linha: linha,
                                        desabilitado: true,
                                        desabilitadoConta: true
                                    }"></ng-container>
                                </div>

                                <div *ngIf="obterLinhasImportadas().length === 0" class="empty-state">
                                    <mat-icon>inbox</mat-icon>
                                    <p>Nenhum lançamento importado ainda</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>

            <!-- Aba: Pendências de Integração -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon tab-icon-integracao">warning</mat-icon>
                    Pendências de Integração
                    <span class="tab-badge tab-badge-integracao" *ngIf="contarPendentesIntegracao() > 0">
                        {{ contarPendentesIntegracao() }}
                    </span>
                </ng-template>

                <div class="lancamentos-container" style="margin-top: 16px;">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Lançamentos com Falha na Integração</mat-card-title>
                            <div class="resumo-header-actions" style="margin-left: auto;">
                                <button mat-raised-button
                                        color="warn"
                                        (click)="reprocessarArquivo()"
                                        matTooltip="Re-executa o processo de integração para todas as linhas importadas"
                                        *ngIf="perfilAcesso.insere || perfilAcesso.altera">
                                    <mat-icon>refresh</mat-icon>
                                    Reprocessar Arquivo
                                </button>
                            </div>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="lancamentos-lista">
                                <div *ngFor="let linha of obterLinhasPendentesIntegracao()"
                                     class="lancamento-item pendencia-integracao"
                                     [class.pendencia-modificada]="isLinhaPendenciaModificada(linha)">

                                    <!-- Linha 1: data, descrição, valor, situação e ações -->
                                    <div class="lancamento-resumo">
                                        <ng-container *ngTemplateOutlet="dadosLancamentoTpl; context: {linha: linha}"></ng-container>

                                        <div class="lancamento-situacao">
                                            <span class="situacao-chip situacao-erro">
                                                <mat-icon>error_outline</mat-icon>
                                                Falha na integração
                                            </span>
                                            <span *ngIf="isLinhaPendenciaModificada(linha)"
                                                  class="situacao-chip situacao-modificada"
                                                  matTooltip="Alteração pendente de salvamento">
                                                <mat-icon>edit</mat-icon>
                                                Alterada
                                            </span>
                                        </div>

                                        <div class="lancamento-acoes" *ngIf="perfilAcesso.insere || perfilAcesso.altera">
                                            <button class="acao-btn"
                                                    mat-button
                                                    (click)="marcarComoCorrigido(linha)"
                                                    matTooltip="Marcar manualmente como corrigido">
                                                <mat-icon style="color: #4caf50;">check_circle</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Linha 2: campos de associação -->
                                    <ng-container *ngTemplateOutlet="camposLancamentoTpl; context: {
                                        linha: linha,
                                        desabilitado: !perfilAcesso.insere && !perfilAcesso.altera,
                                        desabilitadoConta: !perfilAcesso.insere && !perfilAcesso.altera
                                    }"></ng-container>

                                    <!-- Erro de integração -->
                                    <div class="lancamento-erro"
                                         [matTooltip]="linha.descricaoAtualizacaoBase || 'Sem descrição do erro'">
                                        <mat-icon class="erro-icon">error_outline</mat-icon>
                                        <span>
                                            <strong>Erro de Integração:</strong>
                                            {{ linha.descricaoAtualizacaoBase || 'Falha na integração' }}
                                        </span>
                                    </div>
                                </div>

                                <div *ngIf="obterLinhasPendentesIntegracao().length === 0" class="empty-state">
                                    <mat-icon style="color: #4caf50;">check_circle</mat-icon>
                                    <p>Nenhuma pendência de integração</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>

        </mat-tab-group>
    </div>

    <!-- Ações -->
    <div class="acoes">
        <mat-card>
            <mat-card-content>
                <div class="acoes-content">
                    <button mat-button (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                        Voltar
                    </button>
                    <div style="display: flex; gap: 10px;">
                        <button (click)="tentarAssociarTodas()"
                                [disabled]="estatisticas.semContaContabil === 0 || !podePreencherAutomaticamente()"
                                color="accent"
                                mat-raised-button
                                *ngIf="perfilAcesso.insere || perfilAcesso.altera">
                            <mat-icon>auto_fix_high</mat-icon>
                            Auto-Associar
                        </button>
                        <button (click)="salvarTodas()"
                                [disabled]="!podeSalvar()"
                                color="primary"
                                mat-raised-button
                                *ngIf="perfilAcesso.insere || perfilAcesso.altera">
                            <mat-icon>save</mat-icon>
                            Salvar ({{ associacoes.size }})
                        </button>
                        <button (click)="finalizarImportacao()"
                                [disabled]="!podeImportar() || !podeSalvar() || desabilitarBotaoImportar()"
                                class="btn-importar-principal"
                                mat-raised-button
                                *ngIf="perfilAcesso.insere || perfilAcesso.altera"
                                matTooltip="Importar lançamentos associados">
                            <mat-icon>check_circle</mat-icon>
                            Importar
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

</div>
